<div class="custom-pagination" *ngIf="paginas.length > 0" fxLayout="row" fxLayoutAlign="center center"
    fxLayoutGap="5px">
    <div (click)="isFirstPage() !== true ? previous() : ''">
        <a [ngClass]="{'isDisabled': isFirstPage()}" class="pagination-previous pointer" fxLayoutAlign="center center"><span
                fxLayoutAlign="center center">
                <fa-icon class="pointer" [icon]="['fas', 'arrow-left']"></fa-icon>
            </span>
        </a>
    </div>
    <div class="page-number" [ngClass]="{'current-page': isCurrentPage(page)}" fxLayout="row"
        fxLayoutAlign="center center" *ngFor="let page of paginas">
        <span *ngIf="!isCurrentPage(page)" (click)="setCurrent(page)">{{page}}</span>
        <div *ngIf="isCurrentPage(page)">
            <span>{{page}}</span>
        </div>
    </div>
    <div (click)="isLastPage() !== true ? next() : ''">
        <a [ngClass]="{'isDisabled': isLastPage()}" class="pagination-next pointer" fxLayoutAlign="center center">
            <span fxLayoutAlign="center center">
                <fa-icon class="pointer" [icon]="['fas', 'arrow-right']"></fa-icon>
            </span>
        </a>
    </div>
</div>